import { render, staticRenderFns } from "./template.html?vue&type=template&id=b10e0b6c&scoped=true&external"
import script from "./controller.js?vue&type=script&lang=js&external"
export * from "./controller.js?vue&type=script&lang=js&external"
import style0 from "./styles.css?vue&type=style&index=0&id=b10e0b6c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e0b6c",
  null
  
)

export default component.exports